// @ts-nocheck
import { chain, DispatchSetOrderNumber } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/DisplayOrder";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const setBaseParameter = createChainHandler("setBaseParameter", chain, props => {
    if (props.parameter.expand?.includes("shipments")) {
        (props.parameter as any) = {
            ...props.parameter,
            expand: [...props.parameter.expand, "shipments/shipmentpackagelines"],
        };
    }
});

addToChainAfter(chain, DispatchSetOrderNumber, setBaseParameter);
